import { GreyGooseTheme } from "./schemes/GreyGooseTheme";
import { PureLightTheme } from "./schemes/PureLightTheme";
import { PurpleFlowTheme } from "./schemes/PurpleFlowTheme";

const themeMap = {
  PureLightTheme,
  GreyGooseTheme,
  PurpleFlowTheme,
};

export function themeCreator(theme) {
  return themeMap[theme];
}
